msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-31 12:07\n"
"Last-Translator: \n"
"Language-Team: Spanish\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: es-ES\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "Bloqueado"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "Publicaciones: {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "Última publicación: {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automatizado"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1454
msgid "Group"
msgstr "Grupo"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "Mutuo"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "Solicitado"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "Siguiendo"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "Te sigue"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# seguidor} other {# seguidores}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Verificado"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "Se unió el <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Para siempre"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "No se ha podido cargar la cuenta."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Ir a la página de la cuenta"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Seguidores"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Publicaciones"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "Más"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> ha indicado que su nueva cuenta es:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr "Identificador copiado"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr "No se ha podido copiar el identificador"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr "Copiar identificador"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Ir a la página de perfil original"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Ver imagen del perfil"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Ver cabecera del perfil"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "Cuenta conmemorativa"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "Este usuario ha optado por no hacer esta información disponible."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} originales, {1} respuestas, {2} impulsos"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Última publicación en el último día} other {Última publicación en los últimos {2} días}}} other {{3, plural, one {Últimas {4} publicaciones en el último día} other {Últimas {5} publicaciones en los últimos {6} días}}}}"

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Última publicación en el último año(s)} other {Últimas {1} publicaciones en el último año(s)}}"

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Originales"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1428
#: src/pages/catchup.jsx:2039
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "Respuestas"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1430
#: src/pages/catchup.jsx:2051
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "Impulsos"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "Las estadísticas de las publicaciones no están disponibles."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "Ver estadísticas de las publicaciones"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "Última publicación: <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "Silenciado"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "Bloqueado"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "Nota privada"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "Mencionar a <0>@{username}</0>"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "Traducir biografía"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "Editar nota privada"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "Añadir nota privada"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "Notificaciones habilitadas para las publicaciones de @{username}."

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "Notificaciones desactivadas para las publicaciones de @{username}."

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "Desactivar las notificaciones"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "Activar las notificaciones"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "Impulsos de @{username} activados."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "Impulsos de @{username} desactivados."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "Desactivar impulsos"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "Activar impulsos"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "Añadir/Quitar de las listas"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "Enlace copiado"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "No se ha podido copiar el enlace"

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "Copiar"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "Compartir parece no funcionar."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "Compartir…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "No silenciado @{username}"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "Dejar de silenciar a <0>@{username}</0>"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "Silenciar a <0>@{username}</0>…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "Silenciado @{username} para {0}"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "No se ha podido silenciar a @{username}"

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "¿Eliminar a <0>@{username}</0> de los seguidores?"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "@{username} eliminado de los seguidores"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "Eliminar seguidor…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr "¿Bloquear a <0>@{username}</0>?"

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "Desbloqueado @{username}"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "Bloqueado @{username}"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "No se ha podido desbloquear a @{username}"

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "No se ha podido bloquear a {username}"

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr "Desbloquear a <0>@{username}</0>"

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr "Bloquear a <0>@{username}</0>…"

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr "Reportar a <0>@{username}</0>…"

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "Editar perfil"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "¿Retirar la solicitud de seguimiento?"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "¿Dejar de seguir a @{0}?"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "Dejar de seguir…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "Descartar…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Seguir"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1564
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "Cerrar"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "Biografía traducida"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "No se ha podido eliminar de la lista."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "No se ha podido añadir a la lista."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "No se ha podido cargar las listas."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "No hay listas."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Nueva lista"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr "Nota privada acerca de <0>@{0}</0>"

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "No se pudo actualizar la nota privada."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "Cancelar"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "Guardar y cerrar"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "El perfil no ha podido ser actualizado."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "Biografía"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "Campos adicionales"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "Etiqueta"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "Contenido"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "Guardar"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "nombre de usuario"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "nombre de dominio del servidor"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "El modo oculto ha sido desactivado"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "El modo oculto ha sido activado"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:434
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "Inicio"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Redactar"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "Tienes cambios sin guardar. ¿Deseas descartar esta publicación?"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Solo puedes adjuntar hasta 1 archivo.} other {Solo puedes adjuntar hasta # archivos.}}"

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr "Sacar"

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "Minimizar"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr "Parece que cerraste la ventana principal."

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Parece que ya tienes una ventana de edición abierta en la ventana principal y que está publicando actualmente. Por favor, espere a que se publique y vuelva a intentarlo más tarde."

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Parece que ya tienes una ventana de edición abierta en la ventana principal. Entrando en esta ventana se descartarán los cambios que hiciste. ¿Continuar?"

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr "Mostrar"

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Respondiendo al mensaje de @{0}(<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "Respondiendo a la publicación de @{0}"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "Editando la publicación original"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "La encuesta debe tener al menos 2 opciones"

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "Algunas opciones de la encuesta están vacías"

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "Algunos archivos no tienen descripciones. ¿Desear continuar?"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "Error al adjuntar #{i}"

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:978
msgid "Content warning"
msgstr "Advertencia de contenido"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "Advertencia de contenido o medio sensible"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "Público"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "No listado"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "Solo seguidores"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "Mención privada"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "Publica tu respuesta"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "Edita tu publicación"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "¿En qué estás pensando?"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "Añadir advertencia de contenido"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "Añadir una encuesta"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "Insertar emoji personalizado"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "Responder"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "Actualizar"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Publicar"

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "Descargando GIF…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "Fallo al descargar"

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Más…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "Subido"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "Descripción de la imagen"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "Descripción del vídeo"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "Descripción del audio"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "El tamaño del archivo es demasiado grande. Puede que haya problemas al cargar el archivo. Intente reducir el tamaño de {0} a {1} o menos."

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Dimensión demasiado grande. La carga puede encontrar problemas. Intente reducir la dimensión de {0}×{1}px a {2}×{3}px."

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Tasa de fotogramas demasiado alta. La carga podría encontrar problemas."

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Eliminar"

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr "Error"

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr "Editar descripción de la imagen"

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr "Editar descripción del vídeo"

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr "Editar descripción del audio"

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "Generando descripción. Por favor, espera…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "Error al generar la descripción: {0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "Error al generar la descripción"

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "Generar descripción…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "Error al generar la descripción: {0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— experimental</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "Hecho"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "Opción {0}"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "Múltiples opciones"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "Duración"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "Eliminar encuesta"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "Buscar cuentas"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Añadir"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Error al cargar cuentas"

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "Emojis personalizados"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "Buscar emoji"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "Error al cargar emojis personalizados"

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "Utilizado recientemente"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "Otros"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0} más…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "Buscar GIF"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "Con tecnología de GIPHY"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "Escriba para buscar un GIF"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:883
msgid "Previous"
msgstr "Anterior"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:900
msgid "Next"
msgstr "Siguiente"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "Error al cargar los GIF"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "Borradores no enviados"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Parece que tienes borradores sin enviar. Continuemos donde lo dejaste."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "¿Eliminar este borrador?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Error al guardar el borrador. Inténtalo de nuevo."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Eliminar…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "¡Error obteniendo el estado de respuesta!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "¿Borrar todos los borradores?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "¡Error al eliminar borradores! Por favor, inténtalo de nuevo."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Eliminar todo…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "No se encontraron borradores."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1911
msgid "Poll"
msgstr "Encuesta"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Multimedia"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Abrir en una nueva ventana"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "Aceptar"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Cancelar"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "Aceptado"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Cancelado"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Nada que mostrar"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Cuentas"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:516
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "Mostrar más…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:521
#: src/pages/search.jsx:459
msgid "The end."
msgstr "El final."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1602
msgid "Keyboard shortcuts"
msgstr "Atajos del teclado"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Ayuda de atajos de teclado"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1627
msgid "Next post"
msgstr "Siguiente publicación"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1635
msgid "Previous post"
msgstr "Anterior publicación"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Saltar carrusel a la siguiente publicación"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Mayús</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Saltar carrusel a la anterior publicación"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Mayús</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Cargar nuevas publicaciones"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1659
msgid "Open post details"
msgstr "Abrir detalles de la publicación"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Intro</0> u <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Expandir advertencia de contenido o<0/>alternar hilo ampliado/colapsado"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Cerrar publicación o diálogo"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> o <1>Retroceso</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Enfocar columna en el modo de múltiples columnas"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> a <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Redactar nueva publicación"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Redactar nueva publicación (nueva ventana)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Mayús</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Enviar publicación"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Intro</1> o <2>⌘</2> + <3>Intro</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Buscar"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Responder (nueva ventana)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Mayús</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Me gusta (favorito)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> o <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "Impulsar"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Mayús</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "Marcar"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Activar o desactivar el modo oculto"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Mayús</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Editar lista"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "No se ha podido editar la lista."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "No se ha podido crear la lista."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Nombre"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Mostrar respuestas a la lista de miembros"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Mostrar respuestas a las personas que sigo"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "No mostrar respuestas"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Ocultar publicaciones en esta lista de Inicio/Siguiendo"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Crear"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "¿Eliminar esta lista?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "No se ha podido eliminar la lista."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Descripción de la imagen"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Traducir"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "Hablar"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Abrir archivo original en una nueva ventana"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Abrir archivo original"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Intentando describir la imagen. Por favor, espere…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "No se pudo describir la imagen"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Describe la imagen…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Ver publicaciones"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Imagen sensible"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrado: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:967
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1859
msgid "Filtered"
msgstr "Filtrado"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Publicado. Échale un vistazo."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Respuesta publicada. Compruébala."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Publicación actualizada. Compruébala."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menú"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "¿Volver a cargar página ahora para actualizar?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Nueva actualización disponible…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Ponerse al día"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "Menciones"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "Notificaciones"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Nuevo"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Perfil"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Listas"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Todas las listas"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Marcadores"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1429
#: src/pages/catchup.jsx:2045
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "Me gustan"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Etiquetas seguidas"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filtros"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Usuarios silenciados"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Usuarios silenciados…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Usuarios bloqueados"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Usuarios bloqueados…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Cuentas…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Inicie sesión"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "Tendencias"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "Local"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "Federados"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Atajos / Columnas…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Configuración…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Notificación"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Esta notificación procede de tu otra cuenta."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Ver todas las notificaciones"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} reaccionó a tu publicación con {emojiObject}"

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account} ha hecho una publicación."

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} impulsó tu respuesta.} other {{account} impulsó tus publicaciones.}}} other {{account} impulsó {postsCount} de tus publicaciones.}}} other {{postType, select, reply {<0><1>{0}</1> personas</0> impulsaron tu respuesta.} other {<2><3>{1}</3> persona</2> impulsaron tu publicación.}}}}"

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} te comenzó a seguir.} other {<0><1>{0}</1> personas</0> te comenzaron a seguir.}}"

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account} ha solicitado seguirte."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {A {account} le gustó tu respuesta.} other {A {account} le gustó tu publicación.}}} other {A {account} le gustó {postsCount} de tus publicaciones.}}} other {{postType, select, reply {A <0><1>{0}</1> personas</0> les gustó tu respuesta.} other {A <2><3>{1}</3> personas</2> les gustó tu publicación.}}}}"

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "Una encuesta en la que has votado o creado ha finalizado."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr "Una encuesta que has creado ha finalizado."

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr "Una encuesta en la que has votado ha finalizado."

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr "Una publicación con la que interactuaste ha sido editada."

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} impulsó tu respuesta y le gustó.} other {{account} impulsó tu publicación y le gustó.}}} other {{account} impulsó y le gustó {postsCount} de tus publicaciones.}}} other {{postType, select, reply {<0><1>{0}</1> personas</0> impulsaron y les gustó tu respuesta.} other {<2><3>{1}</3> personas</2> impulsaron tu publicación y les gustó.}}}}"

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr "{account} registrado."

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr "{account} reportó {targetAccount}"

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr "Conexiones perdidas con <0>{name}</0>."

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr "Advertencia de moderación"

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Un administrador de <0>{from}</0> ha suspendido <1>{targetName}</1>, lo que significa que ya no puedes recibir actualizaciones de sus cuentas o interactuar con ellas."

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Un administrador de <0>{from}</0> ha bloqueado <1>{targetName}</1>. Seguidores afectados: {followersCount}, siguiendo: {followingCount}."

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Has bloqueado <0>{targetName}</0>. Eliminados seguidores: {followersCount}, siguiendo: {followingCount}."

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr "Tu cuenta ha recibido un aviso de moderación."

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "Tu cuenta ha sido desactivada."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "Se han marcado como sensibles algunas de tus publicaciones."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "Algunas de tus publicaciones han sido eliminadas."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "De ahora en adelante, todas tus publicaciones se marcarán como sensibles."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "Tu cuenta ha sido limitada."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "Tu cuenta ha sido suspendida."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[Tipo de notificación desconocido: {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "Impulsado por/Le gustó a…"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "Le gusta a…"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "Impulsado por…"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "Seguido por…"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "Más información <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "Leer más →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Votado"

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr "Ocultar resultados"

#: src/components/poll.jsx:184
msgid "Vote"
msgstr "Votar"

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "Actualizar"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "Mostrar resultado"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> voto} other {<1>{1}</1> votos}}"

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> votante} other {<1>{1}</1> votantes}}"

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr "Terminado <0/>"

#: src/components/poll.jsx:268
msgid "Ended"
msgstr "Terminado"

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr "Terminando <0/>"

#: src/components/poll.jsx:275
msgid "Ending"
msgstr "Finalizando"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Enlaces maliciosos, interacciones falsas o respuestas repetitivas"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Ilegal"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Viola la ley de tu país o del servidor"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Violación de regla del servidor"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Rompe reglas específicas del servidor"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Violación"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Otros"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "El problema no encaja en otras categorías"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Denunciar esta publicación"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Denunciar @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Revisiones pendientes"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Publicación denunciada"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Perfil reportado"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "No se ha podido denunciar la publicación"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "No se ha podido reportar el perfil"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "¿Cuál es el problema con esta publicación?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "¿Cuál es el problema con este perfil?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Información adicional"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Enviar a <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Enviar reporte"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Silenciar a {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "No se ha podido silenciar a {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Enviar reporte <0>+ Silenciar perfil</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Bloquear a @{username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "No se ha podido bloquear a {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Enviar reporte <0>+ Bloquear perfil</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ cuentas, etiquetas y publicaciones</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Publicaciones con <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Publicaciones etiquetadas con <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Buscar <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Cuentas con <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Inicio / Siguiendo"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Público (Local / Federado)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Cuenta"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Etiqueta"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID de lista"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Solo local"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "Instancia"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr ""

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Buscar término"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Opcional, excepto para el modo de múltiples columnas"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "p. ej. PixelArt (Max 5, separada por espacios)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Solo multimedia"

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Atajos"

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr "versión beta"

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Especifique una lista de atajos que aparecerán como:"

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr "Botón flotante"

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr "Pestaña/Barra de menú"

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr "Múltiples columnas"

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr "No disponible en el modo de vista actual"

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr "Mover hacia arriba"

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr "Mover hacia abajo"

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Editar"

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr "Añadir más de un atajo/columna para hacer que esto funcione."

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr "Aún no hay columnas. Pulse en el botón Añadir columna."

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "No hay atajos todavía. Pulse en el botón Añadir atajo."

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "¿No estás seguro de qué añadir?<0/>Prueba a añadir <1>Inicio / Siguiendo y notificaciones</1> primero."

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Máx. de columnas {SHORTCUTS_LIMIT}"

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Max. de atajos {SHORTCUTS_LIMIT}"

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr "Importar/exportar"

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr "Añadir columna…"

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr "Añadir atajo…"

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "La lista específica es opcional. Para el modo de múltiples columnas, es necesaria una lista; sin ella, no se mostrará la columna."

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Para el modo de múltiples columnas, es necesario un término de búsqueda; sin él, no se mostrará la columna."

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Se permiten múltiples hashtags, separados por espacios."

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr "Editar atajo"

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr "Añadir atajo"

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr "Línea de tiempo"

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr "Lista"

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importar/Exportar <0>Atajos</0>"

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr "Importar"

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr "Pegar atajos aquí"

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr "Descargando atajos guardados desde el servidor de instancia…"

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr "No se han podido descargar los atajos"

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr "Descargando atajos guardados desde el servidor de instancia"

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr "* Existe en los atajos actuales"

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr "La lista puede no funcionar si es de una cuenta diferente."

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr "Formato de ajustes inválido"

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr "¿Añadir a los atajos ya existentes?"

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Solo se agregarán los atajos que no existan en los actuales atajos."

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr "No hay nuevos atajos para importar"

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Atajos importados. Excedido máximo {SHORTCUTS_LIMIT}, por lo que el resto no se importan."

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr "Atajos importados"

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr "Importar y añadir…"

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr "¿Reemplazar los atajos actuales?"

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr "¿Importar atajos?"

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr "o sobreescribir…"

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr "Importar…"

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr "Exportar"

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr "Atajos copiados"

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr "No se ha podido copiar los atajos"

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr "Ajustes de los atajos copiados"

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr "No se ha podido copiar los ajustes de los atajos"

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr "Compartir"

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr "Guardando atajos a la instancia del servidor…"

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr "Atajos guardados"

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr "No se ha podido guardar los atajos"

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr "Sincronizar al servidor de instancia"

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0,plural, one{# carácter} other{# caracteres}}"

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr "No hay más atajos que importar. "

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importar / exportar ajustes del / hacia el servidor de la instancia (En fase muy experimental)"

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>impulsó</1>"

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Lo sentimos, la instancia en la que estás conectado no te permite interactuar con esta publicación de otra instancia."

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr "No me gustó la publicación de {0}"

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr "Me gustó la publicación de {0}"

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr "Dejar de guardar como marcador la publicación de {0}"

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr "Guardado como marcador la publicación de {0}"

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr "Dejar de impulsar"

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr "Cita"

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr "Algunos archivos no tienen descripción."

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr "Antiguas publicaciones (<0>{0}</0>)"

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr "Ya no impulsas la publicación de @{0}"

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr "Has impulsado la publicación de @{0}"

#: src/components/status.jsx:901
msgid "Boost…"
msgstr "Impulsar…"

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr "No me gusta"

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr "Me gusta"

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr "Desmarcar"

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr "Ver publicación de <0>@{0}</0>"

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr "Mostrar historial de edición"

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr "Editado: {editedDateText}"

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr "Insertar publicación"

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr "Conversación no silenciada"

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr "Conversación silenciada"

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr "No se puede quitar el silencio de la conversación"

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr "No se puede silenciar la conversación"

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr "Dejar de silenciar conversación"

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr "Silenciar conversación"

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr "Publicación no anclada del perfil"

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr "Publicación fijada en el perfil"

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr "No se ha podido dejar sin fijar la publicación"

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr "No se ha podido fijar la publicación"

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr "Desanclar del perfil"

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr "Anclar al perfil"

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr "¿Deseas eliminar esta publicación?"

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr "Publicación eliminada"

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr "No se ha podido eliminar la publicación"

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr "Denunciar publicación…"

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr "Me gusta"

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr "Impulsó"

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr "Añadido a marcadores"

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr "Anclado"

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr "Eliminado"

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# respuesta} other {# respuestas}}"

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr "Hilo{0}"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr "Mostrar menos"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr "Mostrar contenido"

#: src/components/status.jsx:2071
msgid "Show media"
msgstr "Mostrar multimedia"

#: src/components/status.jsx:2191
msgid "Edited"
msgstr "Editado"

#: src/components/status.jsx:2268
msgid "Comments"
msgstr "Comentarios"

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr "Mostrar historial de edición"

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr "Error al cargar el historial"

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr "Cargando…"

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr "Código HTML"

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr "Código HTML copiado"

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr "No se puede copiar código HTML"

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr "Archivos adjuntos:"

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr "Emojis de esta cuenta:"

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr "URL estática"

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr "Emojis:"

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr "Notas:"

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Esto es estático, sin estilos y sin guion. Necesitarás añadir tus propios estilos y edición si lo necesitas."

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Las encuestas no son interactivas y se convertirán en una lista con recuento de votos."

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Los adjuntos multimedia pueden ser imágenes, vídeos, audios o cualquier tipo de archivo."

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr "La publicación podría ser editada o eliminada más adelante."

#: src/components/status.jsx:3254
msgid "Preview"
msgstr "Vista previa"

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr "Nota: Esta vista previa está ligeramente definida."

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> impulsó"

#: src/components/timeline.jsx:450
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr "Nuevas publicaciones"

#: src/components/timeline.jsx:551
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr "Inténtalo de nuevo"

#: src/components/timeline.jsx:940
#: src/components/timeline.jsx:947
#: src/pages/catchup.jsx:1876
msgid "Thread"
msgstr "Hilo"

#: src/components/timeline.jsx:962
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrado</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Traducción automática desde {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Traduciendo…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Traducir desde {sourceLangText} (autodetectado)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Traducción automática desde {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Automático ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Error al traducir"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Editando el mensaje original"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "Respondiendo a @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Ahora puedes cerrar esta página."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Cerrar la ventana"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Se requiere iniciar sesión."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr "Ir al inicio"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Publicaciones de la cuenta"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Respuestas)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Impulsos)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Multimedia)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Limpiar filtros"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Limpiar"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Mostrar publicación con respuestas"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Respuestas"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Mostrar publicaciones sin impulsos"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Impulsos"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Mostrar publicaciones con archivos"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Mostrando publicaciones etiquetadas con #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Mostrando publicaciones en {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "No hay nada que ver aquí… todavía."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr "No se han podido cargar las publicaciones"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "No se pudo obtener información de la cuenta"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Cambiar a instancia de la cuenta {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Cambiar a mi instancia (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Mes"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Actual"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Por defecto"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Cambiar a esta cuenta"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr "Cambiar a una nueva pestaña/ventana"

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Ver perfil…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Establecer por defecto"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "¿Cerrar sesión <0>@{0}</0>?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Cerrar sesión…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Añadir una cuenta ya existente"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Aviso: la cuenta <0>Default</0> se cargará siempre primero. Si cambias de cuenta, esta se mantendrá durante la sesión."

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "No se han podido cargar los marcadores."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "en la última hora"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "en las últimas 2 horas"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "en las últimas 3 horas"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "en las últimas 4 horas"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "en las últimas 5 horas"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "en las últimas 6 horas"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "las últimas 7 horas"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "las últimas 8 horas"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "las últimas 9 horas"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "las últimas 10 horas"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "las últimas 11 horas"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "las últimas 12 horas"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "después de 12 horas"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Etiquetas seguidas"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Grupos"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Mostrando {selectedFilterCategory, select, all {todas las publicaciones} original {publicaciones originales} replies {respuestas} boosts {impulsos} followedTags {etiquetas seguidas} groups {grupos} filtered {publicaciones filtradas}}, {sortBy, select, createdAt {{sortOrder, select, asc {más antiguos} desc {más recientes}}} reblogsCount {{sortOrder, select, asc {menos impulsos} desc {más impulsos}}} favouritesCount {{sortOrder, select, asc {menos likes} desc {más likes}}} repliesCount {{sortOrder, select, asc {menos respuestas} desc {más respuestas}}} density {{sortOrder, select, asc {menos denso} desc {más denso}}}} first{groupBy, select, account {, agrupado por autores} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Ponerse al día <0>beta</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1568
msgid "Help"
msgstr "Ayuda"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "¿Qué es esto?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "La puesta al día es una línea de tiempo independiente para tus seguidores, ofreciendo una vista de alto nivel de un vistazo, con una interfaz simple inspirada en el correo electrónico para ordenar y filtrar sin esfuerzo a través de las publicaciones."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Vista previa de la interfaz de puesta al día"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Pongámonos al día"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Pongámonos al día con las publicaciones de las cuentas que sigues."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Muéstrame todas las publicaciones de…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "hasta el máximo"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Ponerse al día"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Superpone tu última puesta al día"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Hasta la última puesta al día ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Nota: es posible que su instancia solo muestre un máximo de 800 publicaciones en la línea temporal de Inicio, independientemente del intervalo de tiempo. Podría ser menos o más."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Anteriormente…"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# publicación} other {# publicaciones}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "¿Eliminar esta actualización?"

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Nota: Solo se almacenará el máximo 3. El resto se eliminará automáticamente."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Obteniendo publicaciones…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Esto podría tardar un rato."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Limpiar filtros"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1574
msgid "Top links"
msgstr "Mejores enlaces"

#: src/pages/catchup.jsx:1260
msgid "Shared by {0}"
msgstr "Compartido por {0}"

#: src/pages/catchup.jsx:1299
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Todos"

#: src/pages/catchup.jsx:1384
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# autor} other {# autores}}"

#: src/pages/catchup.jsx:1396
msgid "Sort"
msgstr "Ordenar"

#: src/pages/catchup.jsx:1427
msgid "Date"
msgstr "Fecha"

#: src/pages/catchup.jsx:1431
msgid "Density"
msgstr "Densidad"

#: src/pages/catchup.jsx:1469
msgid "Authors"
msgstr "Autores"

#: src/pages/catchup.jsx:1470
msgid "None"
msgstr "Nada"

#: src/pages/catchup.jsx:1486
msgid "Show all authors"
msgstr "Mostrar todos los autores"

#: src/pages/catchup.jsx:1537
msgid "You don't have to read everything."
msgstr "No es necesario leer todo."

#: src/pages/catchup.jsx:1538
msgid "That's all."
msgstr "Eso es todo."

#: src/pages/catchup.jsx:1546
msgid "Back to top"
msgstr "Volver arriba"

#: src/pages/catchup.jsx:1577
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Enlaces compartidos por seguidores, ordenados por recuento de compartidos, impulsos y me gustas."

#: src/pages/catchup.jsx:1583
msgid "Sort: Density"
msgstr "Ordenar: densidad"

#: src/pages/catchup.jsx:1586
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Las publicaciones están ordenadas por densidad de información o profundidad. Las publicaciones más cortas son \"más ligeras\" mientras que las publicaciones más largas son \"más pesadas\". Las publicaciones con fotos son \"más pesadas\" que los mensajes sin fotos."

#: src/pages/catchup.jsx:1593
msgid "Group: Authors"
msgstr "Grupo: Autores"

#: src/pages/catchup.jsx:1596
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Las publicaciones están agrupadas por autores, ordenadas por conteo de publicaciones por autor."

#: src/pages/catchup.jsx:1643
msgid "Next author"
msgstr "Siguiente autor"

#: src/pages/catchup.jsx:1651
msgid "Previous author"
msgstr "Autor anterior"

#: src/pages/catchup.jsx:1667
msgid "Scroll to top"
msgstr "Ir arriba"

#: src/pages/catchup.jsx:1858
msgid "Filtered: {0}"
msgstr "Filtrado: {0}"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "No se pueden cargar los \"me gustas\"."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Inicio y listas"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Cronología pública"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Conversaciones"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Perfiles"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Nunca"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Nuevo filtro"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtro} other {# filtros}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "No se han podido cargar los filtros."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "No hay ningún filtro todavía."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Agregar filtro"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Editar filtro"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "No se ha podido editar el filtro"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "No se ha podido crear el filtro"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Título"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Palabra completa"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "No hay palabras clave. Agregue una."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Agregar palabra clave"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# palabra clave} other {# palabras claves}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtrar desde…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Aún no implementado"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Estado: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Cambiar caducidad"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Caducidad"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "La publicación filtrada será…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimizado"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "escondido"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "¿Eliminar este filtro?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "No se ha podido eliminar el filtro."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Caducado"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Caducando <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Nunca caduca"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# etiqueta} other {# etiquetas}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "No se han podido cargar las etiquetas seguidas."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "No se han seguido etiquetas todavía."

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr "No hay resultados para mostrar."

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "No se han podido cargar las publicaciones."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (solo multimedia) en {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} en {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (solo multimedia)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Nadie ha publicado nada con esta etiqueta todavía."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "No se han podido cargar las publicaciones con esta etiqueta"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "¿Dejar de seguir la etiqueta #{hashtag}?"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "Seguido #{hashtag}"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Siguiendo…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "No destacado en el perfil"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "No se puede desactivar en el perfil"

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Destacado en el perfil"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Destacar en el perfil"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {}other {Limite # etiquetas}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Añadir etiqueta"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Eliminar etiqueta"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Se ha alcanzado el límite máximo de # atajos. No se puede añadir el atajo.} other {Se ha alcanzado el límite máximo de # atajos. No se puede añadir el atajo.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Este atajo ya existe"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Atajo de etiqueta añadido"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Añadir a atajos"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Introduzca una nueva instancia, por ejemplo \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr "Instancia inválida"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr "Ir a otra instancia…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Ir a mi instancia (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr "No se pudieron cargar las notificaciones."

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Nuevas</0> <1>solicitudes de seguimiento</1>"

#: src/pages/home.jsx:234
msgid "See all"
msgstr "Ver todo"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Resolviendo…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "No se puede determinar la URL"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Nada aún."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Administrar miembros"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "¿Eliminar a <0>@{0}</0> de la lista?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Eliminar…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# lista} other {# listas}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Aún no hay listas."

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr "No se pudo registrar la aplicación"

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr "ejemplo \"mastodon.social\""

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr "Error al iniciar sesión. Por favor, inténtelo de nuevo o use otra instancia."

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr "Continuar con {selectedInstanceText}"

#: src/pages/login.jsx:233
msgid "Continue"
msgstr "Continuar"

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr "¿No tienes una cuenta? ¡Crea una!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Menciones privadas"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privado"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Nadie te ha mencionado :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "No se han podido cargar los mensajes."

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr "A quienes no sigues"

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr "Que no te siguen"

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr "Con una nueva cuenta"

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr "Quién te mencionan de forma no solicitada"

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr "Quién está limitado por los moderadores del servidor"

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr "Configuración de notificaciones"

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr "Nuevas notificaciones"

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Anuncio} other {Anuncios}}"

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr "Solicitudes de seguimiento"

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# solicitud de seguimiento} other {# solicitudes de seguimiento}}"

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Notificaciones filtradas de # persona} other {Notificaciones filtradas de # personas}}"

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr "Solo menciones"

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr "Hoy"

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr "Estás al día."

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr "Ayer"

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr "No se han podido cargar las notificaciones"

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr "Configuración de las notificaciones actualizada"

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr "Filtrar notificaciones de personas:"

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr "Filtro"

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr "Ignorar"

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr "Actualizado <0>{0}</0>"

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr "Mostrar notificaciones de <0>@{0}</0>"

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr "Notificaciones de <0>@{0}</0>"

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Las notificaciones de @{0} no serán filtradas a partir de ahora."

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr "No se puede aceptar la solicitud de notificación"

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr "Permitir"

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Las notificaciones de @{0} no se mostrarán en las notificaciones Filtradas a partir de ahora."

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr "Imposible descartar el pedido de notificación"

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr "Descartar"

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr "Descartado"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Línea de tiempo local ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Línea temporal federada ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Línea de tiempo local"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Línea temporal federada"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Nadie ha publicado nada todavía."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Cambiar a Federado"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Cambiar a Local"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "Buscar: {q} (Publicaciones)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "Buscar: {q} (Cuentas)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "Buscar: {q} (Etiquetas)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "Buscar: {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Etiquetas"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Ver más"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Ver más cuentas"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "No se encontraron cuentas."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Ver más hashtags"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "No se han encontrado hashtags."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Ver más publicaciones"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "No hay publicaciones."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr "Introduce tu búsqueda o pega una URL para empezar."

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "Ajustes"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "Apariencia"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr "Claro"

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr "Oscuro"

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr "Automático"

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "Tamaño del texto"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr "Idioma en pantalla"

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr "Traducciones voluntarias"

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr "Publicando"

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr "Visibilidad por defecto"

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr "Sincronizado"

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr "Ha ocurrido un error al actualizar la privacidad de la publicación"

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Sincronizado con los ajustes del servidor de tu instancia. <0> Ve a tu instancia ({instance}) para más ajustes.</0>"

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr "Experimentos"

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr "Actualizar automáticamente las publicaciones de tu línea de tiempo"

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr "Carrusel de publicaciones impulsadas"

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr "Traducción de publicaciones"

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr "Traducir a"

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr "Idioma del sistema ({systemTargetLanguageText})"

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural,=0 {Esconder el botón de \"Traducir\" para:} other {Esconder el botón de traducir para (#):}}"

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Nota: Este servicio utiliza servicios de traducción externos, que usan <0>LingvaAPI</0> y <1>LingvaTranslate</1>."

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr "Traducción automática"

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Mostrar automáticamente la traducción para las publicaciones en la línea de tiempo. Solo funciona para mensajes <0>cortos</0> sin advertencias de contenido, archivos multimedia o encuestas."

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr "Selector de GIF durante la redacción"

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Nota: Esta característica emplea un servicio de búsqueda GIF externo, desarrollado por <0>GIPHY</0>. Estos son adecuados para ser vistos por todas las edades, los parámetros de seguimiento son despojados, la información de referencia se omite de las solicitudes, pero las consultas de búsqueda y la información de direcciones IP seguirán llegando a sus servidores."

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr "Generador de descripción de imagen"

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr "Solo para imágenes nuevas mientras se redactan nuevas publicaciones."

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Nota: Esta característica usa un servicio de IA externo, desarrollado por <0>img-alt-api</0>. Puede no funcionar bien. Solamente para imágenes y en inglés."

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr "Notificaciones agrupadas del lado del servidor"

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Función en fase alfa. Ventana de agrupación potencialmente mejorada, pero con una lógica de agrupación básica."

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Importación/exportación \"en la nube\" para la configuración de atajos"

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Muy experimental.<0/>Guardado en las notas de tu propio perfil. Las notas del perfil (privadas) se utilizan principalmente para otros perfiles, y se ocultan para el perfil propio."

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Nota: esta función utiliza la API del servidor de instancias conectado en ese momento."

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Modo oculto <0>(<1>Texto</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Reemplazar el texto por bloques, útil al tomar capturas de pantalla, por motivos de privacidad."

#: src/pages/settings.jsx:692
msgid "About"
msgstr "Acerca de"

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Creado</0> por <1>@cheeaun</1>"

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr "Patrocina"

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr "Dona"

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr "Política de privacidad"

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr "<0>Sitio:</0> {0}"

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versión:</0> <1/> {0}"

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr "Versión copiada"

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr "No se puede copiar la versión"

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr "No se ha podido actualizar la suscripción. Inténtalo de nuevo."

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr "No se ha podido cancelar la suscripción. Inténtalo de nuevo."

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr "Notificaciones (beta)"

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Las notificaciones están bloqueadas. Actívalas en los ajustes de tu navegador."

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr "Permitir desde <0>{0}</0>"

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr "alguien"

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr "personas a las que sigo"

#: src/pages/settings.jsx:999
msgid "followers"
msgstr "seguidores"

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr "Seguidos"

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr "Encuestas"

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr "Publicar ediciones"

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "No se han permitido notificaciones desde la última vez que te conectaste. Necesitarás <0><1>conectarte de nuevo</1> para permitir las notificaciones. </0>."

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "AVISO: Las notificaciones solo se permiten para <0>una cuenta</0>."

#: src/pages/status.jsx:565
msgid "Post"
msgstr "Publicar"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "No estás conectado. No puedes interactuar (responder, impulsar, etc.)."

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Esta publicación es de otra instancia (<0>{instance}</0>). Las interacciones (responder, impulsar, etc.) no son posibles."

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr "Error: {e}"

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr "Cambiar a mi instancia para habilitar interacciones"

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr "No se han podido cargar las respuestas."

#: src/pages/status.jsx:1048
msgid "Back"
msgstr "Volver"

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr "Ir a la publicación principal"

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr "{0} publicaciones arriba - Ir hacia arriba"

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr "Cambiar a vista lateral"

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr "Cambiar a vista completa"

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr "Mostrar todo el contenido sensible"

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr "Experimental"

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr "No se ha podido cambiar"

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr "Cambiar a la instancia de la publicación ({0})"

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr "Cambiar a la instancia de la publicación"

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr "No se ha podido cargar la publicación"

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# respuesta} other {<0>{1}</0> respuestas}}"

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# comentario} other {<0>{0}</0> comentarios}}"

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr "Ver publicación con sus respuestas"

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr "Tendencias ({instance})"

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr "Noticias"

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr "Volver a mostrar publicaciones en tendencia"

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Mostrando publicaciones que mencionan <0>{0}</0>"

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr "Publicaciones en tendencia"

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr "No hay publicaciones en tendencia."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Un cliente web minimalista para Mastodon que hace las cosas a su manera."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Inicie sesión con Mastodon"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Registrarse"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Conecta tu cuenta Mastodon/Fediverse existente.<0/>Tus credenciales no están almacenadas en este servidor."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Creado</0> por <1>@cheeaun</1>. <2>Política de privacidad</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Captura de pantalla del carrusel de impulsos"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Carrusel de publicaciones impulsadas"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Separe visualmente las publicaciones originales de las compartidas (publicaciones impulsadas)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Captura de pantalla del hilo de comentarios anidado"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Hilo de comentarios anidado"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Siga las conversaciones sin problemas. Respuestas semi-colapsables."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Captura de pantalla de notificaciones agrupadas"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Notificaciones agrupadas"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Las notificaciones similares se agrupan y contraen para reducir el desorden."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Captura de pantalla de la interfaz de usuario con múltiples columnas"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Columna simple o múltiple"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Por defecto, una sola columna para los amantes del modo zen. Modo de múltiples columnas ajustable para usuarios avanzados."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Captura de pantalla de línea de tiempo multi-etiqueta con un formulario para añadir más etiquetas"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Línea de tiempo multi-etiqueta"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Hasta 5 etiquetas combinadas en una única línea de tiempo."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Parece que tu navegador está bloqueando ventanas emergentes."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Un borrador de una publicación está minimizado. Publícalo o descártalo antes de crear uno nuevo."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Una publicación está abierta en este momento. Publica o descarta antes de crear una nueva."

